"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseEnableOrDisableUser = UseEnableOrDisableUser;
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../../../utils/theme");
const user_api_1 = require("../../../../utils/api/user/user.api");
function UseEnableOrDisableUser(item) {
    const [toogleActive] = (0, user_api_1.useToogleEnableOrDisableUserMutation)();
    const onToogle = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${(item === null || item === void 0 ? void 0 : item.is_active) ? "désactiver" : "activer"} cet utilisateur ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return toogleActive(item === null || item === void 0 ? void 0 : item.user_id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            var _a;
            console.log(result, "archiver");
            if (result === null || result === void 0 ? void 0 : result.isConfirmed) {
                let val = (_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data;
                console.log('result', result);
                console.log('val', val);
                if ((result === null || result === void 0 ? void 0 : result.value) && (val === null || val === void 0 ? void 0 : val.success)) {
                    sweetalert2_1.default.fire({
                        icon: "success",
                        title: (val === null || val === void 0 ? void 0 : val.message) ||
                            `L'utilisateur a été ${(item === null || item === void 0 ? void 0 : item.is_active) ? "bloqué" : "débloqué"} avec succès!`,
                        iconColor: theme_1.Color.themeColor,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
                else {
                    let err = result === null || result === void 0 ? void 0 : result.value;
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: (val === null || val === void 0 ? void 0 : val.message)
                            ? val === null || val === void 0 ? void 0 : val.message
                            : `Une erreur de statut ${err === null || err === void 0 ? void 0 : err.status} est survenue lors de l'action`,
                        showConfirmButton: false,
                        timer: 5000,
                    });
                }
            }
        });
    });
    return onToogle;
}
